import { VueClass } from 'vue-class-component/lib/declarations';
import { BlockDTO } from '../model/BlockDTO';
import { BoIdMapping } from '../types/BoIdMapping';
import Vue from 'vue';
import { Route } from 'vue-router';

export interface BlockData {
}

export interface PageData {
	boIdMapping: BoIdMapping;
}

export type BlockDataFetcher = (context: Vue, block: BlockDTO) => Promise<BlockData>;

export type PageDataFetcher = (context: Vue) => Promise<PageData>;
export type PageShouldFetchData = (oldRoute: Route, newRoute: Route) => boolean;

export function Block(dataFetcher?: BlockDataFetcher) {
	dataFetcher = dataFetcher || (() => Promise.resolve({}));

	return <VC extends VueClass<any>>(c: VC) => {
		(c as any).dataFetcher = async (context: Vue, block: BlockDTO) => {
			const data = await dataFetcher(context, block);

			return {
				...context.$store.pageData,
				...data
			}
		}
	}
}

export function Page(layout: any, dataFetcher?: PageDataFetcher, needsRefetch?: PageShouldFetchData) {
	dataFetcher = dataFetcher || (() => Promise.resolve({
		boIdMapping: {}
	}));

	needsRefetch = needsRefetch || (() => true);

	return <VC extends VueClass<any>>(c: VC) => {
		(c as any).layout = layout;

		(c as any).dataFetcher = async (context: Vue) => {
			return await dataFetcher(context);
		};

		(c as any).needsRefetch = needsRefetch;
	}
}
